import TipItem from './TipItem'

export default TipItem
